import { useQuery } from '@tanstack/react-query';
import { getCrmView, type CrmView } from '@/api/installation.api';

/**
 * Vista de CRM de la instalación (opciones de la ficha del lead, moneda,
 * catálogo resumido). Cacheada: cambia solo cuando un admin edita la config.
 * Devuelve `undefined` mientras carga o si falla — los consumidores caen a los
 * defaults del piloto (ver lead-fields), así la ficha nunca queda vacía.
 */
export function useCrmView(): CrmView | undefined {
  const { data } = useQuery({
    queryKey: ['installation', 'crm'],
    queryFn: getCrmView,
    staleTime: 5 * 60_000,
    retry: 1,
  });
  return data;
}
